export default __webpack_public_path__ + "static/media/res-park.e0c2b687.png";